// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".p-inputtextarea-resizable{overflow:hidden;resize:none}.p-fluid .p-inputtextarea{width:100%}", ""]);
// Exports
module.exports = exports;
